<template>
  <div class="app-window app-page__wrapper">
    <div class="app-page__content">
      <div class="filters">
        <div class="filter__container">
          <label for="season" class="sr-only">Season</label>
          <select name="season" id="season" class="filter__select" v-model="selectedSeason" :class="{ 'inactive' : !selectedSeason }" @change="selectSeason()">
            <option value="">All seasons</option>
            <option v-for="season in seasons" :key="season" :value="season">Season {{ season }}</option>
          </select>
        </div>
        <div class="filter__container">
          <label for="tags" class="sr-only">Season</label>
          <select name="tags" id="tags" class="filter__select" v-model="selectedTag" :class="{ 'inactive' : !selectedTag }" @change="selectTag()">
            <option value="">All tags</option>
            <option v-for="tag in tags" :key="tag" :value="tag">{{ tag }}</option>
          </select>
        </div>
      </div>
      <ul class="episodes-view__list">
        <episode v-for="(video, index) in videoList" :key="index" :episode="video" :index="index" />
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
.episodes-view {
  &__list {
    list-style: none;
    padding: 0 35px 64px 35px;
  }
}

.filters {
  padding: 30px 35px;
  display: flex;
  gap: 20px;
}

.filter__select {
  width: 115px;
  font-size: 0.75em;
  font-weight: 700;
  text-transform: uppercase;
  background: none;
  border: none;
  color: #FC8B00;
  -webkit-appearance: none;
  padding-right: 25px;
  background-image: url('../assets/arrow-down.svg');
  background-position: 91px -2px;
  background-repeat: no-repeat;
  &.inactive {
    color: rgba(255, 255, 255, 0.5);
    background-image: url('../assets/arrow-down-white.svg');
  }
}
</style>

<script>
import utils from '../utils'
import episode from './Episode'

export default {
  name: 'episodesView',
  components: { episode },
  data () {
    return {
      selectedSeason: '',
      selectedTag: ''
    }
  },
  computed: {
    videoList () {
      const filter = item => { return (this.selectedSeason === '' || item.season === this.selectedSeason) && (this.selectedTag === '' || (item.filters && item.filters.includes(this.selectedTag))) }
      return this.$store.state.videoList.filter(filter)
    },
    currentIndex () {
      return this.$store.state.currentVideo
    },
    hasVideos () {
      return this.$store.getters.hasVideos
    },
    currentVideo () {
      return this.hasVideos ? this.videoList[this.currentIndex] : this.$store.getters.emptyEpisode
    },
    seasons () {
      return new Set(this.$store.state.videoList.map(x => x.season))
    },
    tags () {
      return new Set(this.$store.state.filterList)
    }
  },
  methods: {
    selectSeason () {
      if (this.selectedSeason) {
        this.selectedTag = ''
      }
    },
    selectTag () {
      if (this.selectedTag) {
        this.selectedSeason = ''
      }
    }
  },
  metaInfo () {
    return {
      title: 'Episodes | How To Fix Democracy',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: utils.getDefaultDescription()
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Episodes | How To Fix Democracy'
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: utils.getDefaultDescription()
        }
      ]
    }
  },
  mounted () {
    this.$store.commit('setHomepageVideoEffect', false)
    this.$store.commit('setNavigation', true)
  }
}
</script>
